import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form, message } from 'antd'
import ProfileInfo from './ProfileInfoFields'
import FormUtil from '../../utils/FormUtil'
import { signupComplete } from '../../actions/UserActions'
import { resetBooking } from '../../actions/BookingActions'
import { connect } from 'react-redux'
import ErrorMessage from '../form/ErrorMessage'
import UserService from '../../services/UserService'
import { extractAPIError, notifyError } from '../../utils/Util'
import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'

class SignupModal extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  state = {
    visible: this.props.visible,
    isLoading: false,
    error: null
  }

  async onSignup(event) {
    const { form } = this.props
    event.preventDefault()

    const { errors, values } = await FormUtil.validateForm(form)
    if (!errors) {
      this.signupUser(values)
    }
  }

  async signupUser(userInfo) {
    const { signupComplete, resetBooking } = this.props
    this.setState({ isLoading: true })
    try {
      const response = await UserService.signupUser(userInfo)
      const createdUserDetails = response.user
      if (createdUserDetails) {
        message.success('Account created successfully')
        resetBooking()
        signupComplete(createdUserDetails)
        ReactGA.event({
          category: 'Account',
          action: 'Signup',
          label: 'CompleteRegistration'
        })
        ReactPixel.track('CompleteRegistration')
        //this.setState({ isLoading: false, visible: false })
      }
    } catch (err) {
      const errMsg = extractAPIError(err)
      console.error('Error during signup ' + errMsg)
      this.setState({ isLoading: false, error: errMsg })
      notifyError(err)
      ReactGA.event({
        category: 'Account',
        action: 'Signup',
        label: 'Registration Error'
      })
      ReactPixel.track('Registration Error')
    }
  }

  onCancel(e) {
    this.setState({ visible: false })
  }

  showSignupModal() {
    this.setState({ visible: true })
  }

  /**
   * Form to display if user is not logged in
   */
  render() {
    const { getFieldDecorator } = this.props.form
    const { isLoading, error } = this.state
    return (
      <div
        onKeyPress={event => {
          if (event.key === 'Enter') return this.onSignup(event)
        }}>
        <Modal
          visible={this.state.visible}
          confirmLoading={isLoading}
          okText="Sign-Up"
          onOk={e => this.onSignup(e)}
          onCancel={e => this.onCancel(e)}
          destroyOnClose={true}>
          <Form layout="vertical" hideRequiredMark={true}>
            <ProfileInfo
              form={this.props.form}
              getFieldDecorator={getFieldDecorator}
              isLoggedIn={false}
            />
          </Form>
          <ErrorMessage errorMessage={error} />
        </Modal>
      </div>
    )
  }
}

const WrappedSignupModal = Form.create()(SignupModal)
const mapStateToProps = (state, ownProps) => ({ userState: state.user })
export default connect(mapStateToProps, {
  signupComplete,
  resetBooking
})(WrappedSignupModal)



// WEBPACK FOOTER //
// ./src/components/login/SignupModal.js